import React from 'react';
import styled from 'styled-components';
import { Center } from '../../shared/styles';

type EmptyStateType = {
  imgSrc: string;
  title?: string;
  message?: string;
  children?: any;
  minHeight?: any;
  minWidth?: any;
  id?: string;
};

const EmptyState = (props: EmptyStateType) => {
  const { message, title, children, imgSrc, minHeight, minWidth } = props;
  return (
    <Center minHeight={minHeight ?? '700px'}>
      <StyledEmptyState minWidth={minWidth ?? '600px'}>
        <div className="empty-state-icon">
          <img src={`/${imgSrc}`} alt="empty state" />
        </div>
        <div className="empty-state-title">{title}</div>
        <div className="empty-state-message">{message}</div>
        <div className="empty-state-action">{children}</div>
      </StyledEmptyState>
    </Center>
  );
};

export default EmptyState;

const StyledEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  width: ${(props: any) => props.minWidth || '600px'};

  .empty-state-icon {
    width: 192px;
    margin-bottom: 28px;
  }
  .empty-state-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #12344d;
    margin-bottom: 0.5rem;
  }
  .empty-state-message {
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #12344d;
    max-width: 600px;
  }
  .empty-state-action {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    text-align: center;
    margin-top: 24px;
  }
`;
